import React, { FC } from 'react';
import { useWindowSize } from 'react-use';
import styled from 'styled-components';

import rightArrow from 'assets/images/mobile-nav-arrow-right.svg';

import color from 'atoms/colors/colors';

import Text from 'quarks/Text';
import type { BasicProps } from 'quarks/interpolations/basic';

import ComponentButton from 'components/Button/ComponentButton';

export interface MobileMenuProps extends BasicProps {
  elementMenu?: any[]; // Replace 'any' with the actual type for elementMenu
  isMobileNavOpen?: boolean;
  mobileHeaderHeight?: string;
  openMenu?: number;
  setOpenMenu?: React.Dispatch<React.SetStateAction<number>>;
  setOpenMenuGroup?: any;
  setParentOpen?: any;
}

const MobileMenuParentMenu: FC<MobileMenuProps> = ({
  elementMenu,
  isMobileNavOpen,
  mobileHeaderHeight,
  openMenu,
  setOpenMenu,
  setOpenMenuGroup,
  setParentOpen,
}) => {
  const { height } = useWindowSize();

  const getProductsHeading = (parent: any, index: number) => {
    const navigationItems = [
      {
        type: 'Operations Suite',
        description: 'An end-to-end solution to help grow your business',
      },
      {
        type: 'Marketing Pro',
        description: 'Put your campaigns on easy mode with marketing automation',
      },
      {
        type: 'Fleet Pro',
        description: 'Empower a safer and more productive team',
      },
    ];

    return (
      <>
        <div className="products-item-heading" key={`menu-item-${index}`}>
          <Text as="p" fontSize="textXs" fontWeight="bold">
            {parent.heading}
          </Text>
        </div>

        {navigationItems.map((item, subIndex) => (
          <div
            key={`menu-item-${index}`}
            onClick={() => {
              setOpenMenu && setOpenMenu(index);
              setOpenMenuGroup && setOpenMenuGroup(subIndex);
              setParentOpen && setParentOpen(false);
            }}
            className="mobile-menu-item products-item"
            role="presentation"
          >
            <Text as="p" fontSize="textXs" fontWeight="bold">
              {item.type}
            </Text>
            <Text as="p" fontSize="textXs" className="heading-description">
              {item.description}
            </Text>
          </div>
        ))}
      </>
    );
  };

  return (
    <Container
      className={`mobile-parent-menu ${openMenu === -1 ? 'open' : 'closed'}`}
      mobileHeaderHeight={mobileHeaderHeight}
      isMobileNavOpen={isMobileNavOpen}
      height={height}
    >
      {elementMenu?.map((parent, index) =>
        parent.heading === 'Products' ? (
          getProductsHeading(parent, index)
        ) : (
          <div
            key={`menu-item-${index}`}
            onClick={() => {
              setOpenMenu && setOpenMenu(index);
              setParentOpen && setParentOpen(false);
            }}
            className="mobile-menu-item"
            role="presentation"
          >
            <Text as="p" fontSize="textXs" fontWeight="bold">
              {parent.heading}
            </Text>
          </div>
        ),
      )}
      <div className="mobile-parent-ctas">
        <ComponentButton link="/pro/marketing" buttonColor="Black" label="Upgrade to Pro" />
        <ComponentButton link="/login" buttonColor="Outline Gray" label="Sign In" />
      </div>
    </Container>
  );
};

export default MobileMenuParentMenu;

const Container = styled.div`
  position: absolute;
  left: 0;
  top: ${({ mobileHeaderHeight }) => mobileHeaderHeight};
  border-top: ${({ isMobileNavOpen }) => (isMobileNavOpen ? '1.5px solid #E8E8E8' : null)};
  width: 100vw;
  height: ${({ height, mobileHeaderHeight, isMobileNavOpen }) =>
    isMobileNavOpen ? `calc(${height + 1}px - ${mobileHeaderHeight})` : '0px'};
  transition: height 0s ease-in-out;
  background-color: common-white;
  z-index: 10;
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  display: flex;

  &:hover {
    cursor: pointer;
  }

  .sub-menu-group {
    gap: 25px;
  }

  .mobile-menu-item {
    display: flex;
    padding: 20px 30px;
    border-bottom: 0.75px solid var(--Gray-300, #e8e8e8);
    background-image: url(${rightArrow});
    background-position-x: calc(100% - 35px);
    background-position-y: center;
    background-repeat: no-repeat;
    flex-direction: column;
    padding: 25px;
    gap: 35px;

    h4 {
      padding: 0;
    }

    p {
      color: ${color.gray[900]};
      text-align: left;
    }
  }

  .products-item {
    background-position-y: 28px;
    background-color: var(--Gray-200, #f3f3f3);
    gap: 10px;

    .heading-description {
      max-width: calc(100% - 35px);
      text-align: left;
      line-height: 18px;
    }
  }

  .mobile-parent-ctas {
    display: flex;
    gap: 10px;
    padding: 24px;
    flex-direction: column;

    button {
      text-transform: none;
      min-width: 100%;
      font-size: 14px;
    }
  }

  .products-item-heading {
    display: flex;
    background-color: var(--Gray-200, #f3f3f3);
    padding: 20px 25px;
    border-bottom: 0.75px solid var(--Gray-300, #e8e8e8);

    &:hover {
      cursor: auto;
    }

    p {
      color: ${color.gray[900]};
    }
  }

  @media (min-width: 992px) {
    flex-direction: row;
    position: unset;
    width: auto;
    overflow-x: unset;
    overflow-y: unset;
    align-items: center;
    min-height: 96px;
    background-color: transparent;
  }
`;
